import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import humanTime from 'flarum/common/utils/humanTime';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import Icon from 'flarum/common/components/Icon';
import Tooltip from 'flarum/common/components/Tooltip';
import octicons from '../utils/octicons';
import ProgressBar from 'ext:sycho/flarum-uikit/common/components/ProgressBar';
import LabelGroup from 'ext:sycho/flarum-uikit/common/components/LabelGroup';
import Label from 'ext:sycho/flarum-uikit/common/components/Label';
import tagsLabel from 'ext:flarum/tags/common/helpers/tagsLabel';
export default class IssueListItem extends Component {
  view() {
    const issue = this.attrs.issue;
    return m("div", {
      class: "DiscussionListItem"
    }, m("div", {
      class: "DiscussionListItem-content"
    }, m("div", {
      class: "DiscussionListItem-author"
    }, m(Tooltip, {
      text: app.translator.trans('core.forum.discussion_list.started_text', {
        username: issue.user().login,
        ago: humanTime(issue.createdAt())
      }),
      position: "right"
    }, m("a", {
      class: "DiscussionListItem-author-avatar",
      href: issue.user().html_url
    }, m("img", {
      class: "Avatar",
      loading: "lazy",
      src: issue.user().avatar_url,
      alt: ""
    }))), m("ul", {
      class: "DiscussionListItem-badges badges badges--packed"
    }, listItems(this.badgeItems(issue).toArray()))), m("a", {
      href: issue.htmlUrl(),
      class: "DiscussionListItem-main"
    }, m("h2", {
      class: "DiscussionListItem-title"
    }, issue.title()), m("ul", {
      class: "DiscussionListItem-info"
    }, listItems(this.infoItems(issue).toArray()))), m("div", {
      class: "DiscussionListItem-stats"
    }, m("span", {
      class: "DiscussionListItem-stats-item DiscussionListItem-count"
    }, m("span", {
      class: "DiscussionListItem-stats-item-icon"
    }, m("i", {
      "aria-hidden": "true",
      class: "icon far fa-comment"
    })), m("span", {
      class: "DiscussionListItem-stats-item-label"
    }, m("span", {
      "aria-hidden": "true"
    }, issue.comments()))))));
  }
  getTasks() {
    const pendingTasksCount = (this.attrs.issue.body().match(/\r\n- \[ \]/g) || []).length;
    const doneTasksCount = (this.attrs.issue.body().match(/\r\n- \[x\]/g) || []).length;
    return {
      current: doneTasksCount,
      total: doneTasksCount + pendingTasksCount
    };
  }
  badgeItems(issue) {
    const items = new ItemList();
    let type = 'issue';
    let state = issue.state();
    if (issue.pullRequest()) {
      type = 'pull';
      if (issue.pullRequest().merged_at) {
        state = 'merged';
      }
    }
    if (issue.state() === 'closed' && issue.stateReason() === 'completed') {
      state = 'merged';
    }
    if (state) {
      items.add('state', m("span", {
        className: "Badge GithubMilestone-Badge",
        style: {
          backgroundColor: octicons[type][state].color
        }
      }, octicons[type][state].icon));
    }
    return items;
  }
  infoItems(issue) {
    const items = new ItemList();
    items.add('terminalPost', m("span", null, m(Icon, {
      name: "far fa-clock"
    }), " ", app.translator.trans('sycho-github-milestone.forum.last_updated', {
      time: humanTime(issue.updatedAt())
    })));
    const tasks = this.getTasks();
    if (tasks.total) {
      items.add('github-tasks', m("span", null, m(Icon, {
        name: "fas fa-tasks"
      }), ' ', app.translator.trans('sycho-github-milestone.forum.tasks_done', {
        number: tasks.current,
        total: tasks.total
      }), m(ProgressBar, {
        progress: tasks.current * 100 / tasks.total,
        mini: true
      })));
    }
    if ('flarum-tags' in flarum.extensions) {
      items.add('tags', tagsLabel(issue.labels().map(l => ({
        color: () => '#' + l.color,
        name: () => l.name,
        isChild: () => false,
        slug: () => l.name,
        icon: () => null
      }))));
    } else {
      items.add('github-labels', m(LabelGroup, null, issue.labels().map(label => m(Label, {
        color: label.color
      }, label.name))));
    }
    return items;
  }
}
flarum.reg.add('sycho-github-milestone', 'forum/components/IssueListItem', IssueListItem);